import { render, staticRenderFns } from "./TaxInvoice.vue?vue&type=template&id=2c3af70f&scoped=true&"
import script from "./TaxInvoice.vue?vue&type=script&lang=js&"
export * from "./TaxInvoice.vue?vue&type=script&lang=js&"
import style0 from "./TaxInvoice.vue?vue&type=style&index=0&id=2c3af70f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3af70f",
  null
  
)

export default component.exports